import { AbstractMessageHandler } from "@/services/rest/messages/message-handler";
import { XmlRequest } from "@/services/rest/xml-request";
import { getRequiredAttribute, getRequiredChild } from "@/utils/xml-helper-functions";
import { LocalizedError } from "@/services/rest/errors";

export class AUs15ResetPassword extends AbstractMessageHandler<boolean> {
    protected readonly requestType: string = "A.US.1.5";

    constructor (readonly phone: string) {
        super();
    }

    buildRequest (request: XmlRequest) {
        const actionElement = request.addChild(request.body, "action", {
            type: this.requestType
        });
        request.addChildWithValue(actionElement, "Phone", this.phone);
        request.addChildWithValue(actionElement, "ConfirmationMethod", "phone");
    }
    // eslint-disable-next-line
    parseMessageBody (body: Element, _head: Element): boolean {
        const action = getRequiredChild(body, "action");
        const serverCode = getRequiredAttribute(action, "servercode");
        if (serverCode === "1160") {
            return true;
        }
        throw new LocalizedError(`errors.mtl.code${serverCode}`);
    }
}
